import Vue from 'vue';
import { ToastOptions } from 'vue-toasted';

export const useToast = () => {
  return {
    ...Vue.toasted,
    info: (msg: string, opt?: ToastOptions) =>
      Vue.toasted.info(msg, { ...opt, duration: Infinity }),
    error: (msg: string, opt?: ToastOptions) =>
      Vue.toasted.error(msg, { ...opt, duration: Infinity }),
  };
};
